export default {"src":"/_next/static/media/ic-order.5d63891a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};